export interface PurchaseOrderInvoiceSearchDto {
    page: number;
    limit: number;
    search?: string;
    sort?: string;
    sortDir?:  'ASC' | 'DESC';
    merchantId?: number;
    statusId?: number;
    supplierId?: number;
}